import React from 'react';
import PropTypes from 'prop-types';

import { Text, View, Image, StyleSheet } from '@react-pdf/renderer';

import welltravelLogo from 'affiliateImages/branding_assets/welltravel_logo_small.png';
import PdfStyles from './PdfStyles';

const PdfHeader = ({ welltravelName, welltravelAddress1, welltravelAddress2, welltravelVat }) => {
  const styles = StyleSheet.create(PdfStyles);

  return (
    <View style={styles.header}>
      <View style={styles.headerBrand}>
        <Image style={styles.logo} src={welltravelLogo} />
      </View>
      <View style={styles.headerInfo}>
        <Text style={styles.company}>{welltravelName}</Text>
        <Text style={styles.address}>{welltravelAddress1}</Text>
        <Text style={styles.address}>{welltravelAddress2}</Text>
        <Text style={styles.vat}>{welltravelVat}</Text>
      </View>
    </View>
  );
};

PdfHeader.propTypes = {
  welltravelName: PropTypes.string.isRequired,
  welltravelAddress1: PropTypes.string.isRequired,
  welltravelAddress2: PropTypes.string.isRequired,
  welltravelVat: PropTypes.string.isRequired,
};

export default PdfHeader;
